import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import {
    SelectItem,
    Message,
    ConfirmationService
} from 'primeng/primeng';

import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Order } from '../../shared/classes/order';
import { OrdersService } from '../../shared/services/orders.service';
import { OneOrderShoppingItem } from '../../shared/classes/oneOrderShoppingItem';
import { MembersService } from '../../shared/services/members.service';
import { MerchantService } from '../../shared/services/merchant.service';
import { ConfigService } from '../../config/config.service';
import { CommonDataService } from '../../shared/services/common-data.service';
import {SettingsService} from '../../shared/services/settings.service';
import { HostListener } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {EmployeesService} from '../../shared/services/employees.service';
const platform = require('platform');

@Component({
  selector: 'app-add-edit-orders',
  templateUrl: './add-edit-orders.component.html',
  styleUrls: ['./add-edit-orders.component.css']
})

export class AddEditOrdersComponent implements OnInit {
    hideUI: boolean = false;
    isNew: boolean = true;
    header: string = '';
    selectedCustomer: any = null;
    selectedCustomerId: number = -1;
    selectedCustomerName: string = '';
    foundMembers: Object[];
    isCreateNewCustomer: boolean = false;
    productsDropdown: SelectItem[];
    attributionDropdown: SelectItem[];
    paymentMethodDropdown: SelectItem[];
    shippingDropdown: SelectItem[];
    paymentLocationDropdown: SelectItem[];
    representativeDropdown: SelectItem[];
    attributionDisabled: boolean = true;

    searchedCustomer: string;
    shoppingCard: OneOrderShoppingItem[];
    shippingPrice: number = 0;
    subtotal: number = 0;
    grandTotal: string = '0';
    taxes: string = '0';
    /*attribution: string = undefined;*/
    selectedPaymentMethod: string = undefined;
    selectedPaymethodRadioBtn: string = 'Yes';
    selectedPaymentLocation: string = undefined;
    selectedPaymentIsCard: any = {
        fname: '',
        lname: '',
        number: '',
        ccv: '',
        expirationMonth: '',
        expirationYear: ''
    };
    sellectedShipping: string = undefined;
    selectedRepresentative: any;
    newMemberAddressSubmitted: boolean = false;
    newShippingAddressObj: any = {
        name: '',
        address: '',
        apartment: '',
        suite: '',
        city: '',
        state: 'CA',
        zip: ''
    };
    msgsNewAddress: Message[] = [];
    msgProduct: Message[] = [];
    msgSearchMember: Message[] = [];
    msgs: Message[] = [];
    orderSaveMsgs: Message[] = [];
    orderSaved: boolean = false;
    productsHolder: any[];

    // member part
    editMembersData: FormGroup;
    firstName: string = '';
    lastName: string = '';
    phone: string = '(805) ';
    mobilePhone: string = '(805) ';
    email: string = '';
    password: string = '';
    rePassword: string = '';
    gender: string = '';
    birthDate: any = '';
    address: any = '';
    apartment: any = '';
    country: any = 'United States';
    aptSuite: any = '';
    city: any = '';
    state: string = 'CA';
    zip: any = '';
    subscribeToNewsletter: boolean = false;
    orderPaid: boolean = false;
    fullShippingDD: any[] ;
    submitted: boolean = false;
    msgMember: Message[] = [];
    success: boolean = false;
    member: string;
    yearsRange =  new Date().getFullYear() - 120 + ':' + new Date().getFullYear();
    incomes;
    homeOwner;
    householdMembers;
    states;
    incorrectZip: boolean = false;
    market: string = '';
    markets: any[] = [];
    membermarket: string = '';
    //End member part

    submitCode: boolean = false;
    promoCode: string = '';
    promoCodeDiscount: number = 0;
    promoCodeStatus: string = 'inactive';

    allProducts: any[] = [];
    beneficiariesDisabled = true;
    beneficiariesList = [];
    selectedType = '';
    types = [
        {id: 1, value: 'SCHOOL', label: 'Schools'},
        {id: 2, value: 'NONPROFIT', label: 'Non - Profit'}
    ];
    beneficiaries = [];
    selectedBeneficiary = '';
    additionalInfo = '';
    platformDesc = '';

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        // insert logic to check if there are pending changes here;
        // returning true will navigate without confirmation
        // returning false will show a confirm dialog before navigating away
        return !this.commonDataService.unsavedChanges;
    }

    confirm(observer) {
        this.confirmationService.confirm({
            message: 'You haven’t saved this order yet. Do you want to leave without saving?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.commonDataService.setUnsavedChanges(false);
                observer.next(true);
                observer.complete();
            },
            reject: () => {
                observer.next(false);
                observer.complete();
            }
        });
    }

    constructor(private route: ActivatedRoute,
        private router: Router,
        private ordersService: OrdersService,
        private membersService: MembersService,
        private activatedRoute: ActivatedRoute,
        private configService: ConfigService,
        private commonDataService: CommonDataService,
        private settingsService: SettingsService,
        private confirmationService: ConfirmationService,
        private employeesService: EmployeesService,
        ) { }

    ngOnInit() {
        this.fillMarketsDropdown();
        this.fillBeneficiariesDropdown();
        this.foundMembers = [];
        this.msgs = [];
        this.msgSearchMember = [];
        this.msgProduct = [];
        this.msgsNewAddress = [];

        this.route.params.subscribe(params => {
            this.header = params['id'];
        });
        this.hideUI = true;

        this.fillPaymentLocationDropdown();
        // edit order logic

        if (this.header.startsWith('New') && !isNaN(Number(this.header.substr(3)))) {
            const obj = {
                'id': Number(this.header.substr(3)),
                'fullName': this.commonDataService.getCache('comeFromMemberDetaisWithname')
            };
            if (obj.fullName && obj.id) {
                this.selectMember(obj);
            }
        }

        // member:
        this.formControlsMember();
        this.incomes = this.commonDataService.annualHouseholdIncome;
        this.householdMembers = this.commonDataService.householdMembers;
        this.homeOwner = this.commonDataService.homeOwner;
        this.states = this.commonDataService.states;

        //will call waterfall calls due to refresh token synchronization of calls
        this.fillProductsDropdown();
        this.platformDesc = platform.description;
    }

    ///new member part:
    formControlsMember() {
        this.editMembersData = new FormGroup({
            'firstName': new FormControl('', Validators.required),
            'lastName': new FormControl('', Validators.required),
            'market': new FormControl('', Validators.required),
            'email': new FormControl('', Validators.required),
            'phone': new FormControl('(805) '),
            'mobilePhone': new FormControl('(805) '),
            'password': new FormControl('', [this.passwordsEmpty]),
            'rePassword': new FormControl('', [this.passwordsEmpty]),
            'gender': new FormControl('', Validators.required),
            'birthDate': new FormControl('', Validators.required),
            'annualIncome': new FormControl(''),
            'homeOwner': new FormControl(''),
            'householdMembers': new FormControl(''),
            'address': new FormControl(''),
            'apartment': new FormControl(''),
            //'country': new FormControl(''),
            'aptSuite': new FormControl(''),
            'city': new FormControl(''),
            'state': new FormControl('CA'),
            'zip': new FormControl('', Validators.required),
            'subscribeToNewsletter': new FormControl('')
        });
        this.state = 'CA';
    }

    resetForm() {
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.password = '';
        this.rePassword = '';
        this.gender = '';
        this.birthDate = '';
        this.phone = '(805) ';
        this.mobilePhone = '(805) ';
        this.address = '';
        this.apartment = '';
        //this.country = '';
        this.aptSuite = '';
        this.city = '';
        this.state = 'CA';
        this.zip = '';
        this.subscribeToNewsletter = false;
        this.submitted = false;
        this.membermarket = '';
        this.msgMember = [];
    }

    passwordsEmpty = (control: FormControl): { [s: string]: boolean } => {
            if (control.value === '') {
                return { telEmpty: true };
            }
        return null;
    }

    fillBeneficiariesDropdown(): void {
        this.beneficiaries = [{
            label: 'Select a Purchase Beneficiary',
            value: ''
        }];
        const params = {
            'filter': {
                'fields': [
                    {
                        'field': 'status',
                        'value': 'ENABLED'
                    }
                ]
            },
            'sorting': [
                {
                    'property': 'name',
                    'direction': 'ASC'
                }
            ],
            'paging': {
                'page': 1,
                'numRows': 0
            }
        };

        this.settingsService.listBeneficiary(params)
            .subscribe(
                data => {
                    if (data) {
                        this.beneficiariesList = data.beneficiaries;
                    }
                },
                error => {
                    // this.hideUI = false;
                    console.log('Error', error);
                }
            );
    }

    onFilter = () => {
        this.beneficiaries = [];
        this.beneficiariesDisabled = false;
        this.beneficiariesList.forEach(beneficiary => {
            if (beneficiary.type === this.selectedType) {
                this.beneficiaries.push({
                    label: beneficiary.name,
                    value: beneficiary.id
                });
            }
        });
    }


    onSubmit() {
        this.incorrectZip = false;
        this.msgMember = [];
        this.submitted = true;

        let userData = this.commonDataService.deleteEmptyObjectProperties(this.commonDataService.trimObjectData(this.editMembersData.value));
        if (this.editMembersData.valid === false) {
            this.msgMember.push({severity: 'error', detail: 'Please fill the required fields'});
        } else if (userData.phone && !this.commonDataService.isValidPhone(userData.phone)) {
            if (userData.phone.length < 9) {
                this.msgMember.push({
                    severity: 'error',
                    detail: 'Phone number is too short'
                });
            } else {
                this.msgMember.push({
                    severity: 'error',
                    detail: 'Please fill valid number'
                });
            }
        } else if (userData.mobilePhone && !this.commonDataService.isValidPhone(userData.mobilePhone)) {
            if (userData.mobilePhone.length < 9) {
                this.msgMember.push({
                    severity: 'error',
                    detail: 'Mobile Phone number is too short'
                });
            } else {
                this.msgMember.push({
                    severity: 'error',
                    detail: 'Please fill valid number'
                });
            }
        } else if (userData.password !== userData.rePassword) {
            this.msgMember.push({severity: 'error', detail: 'Passwords don\'t match'});
        } else if (isNaN(userData.zip) && userData.zip !== undefined) {
            this.msgMember.push({severity: 'error', detail: 'ZIP code should contain digits only'});
            this.incorrectZip = true;
        } else if (!userData.password || userData.password.length < 6 || userData.password.length > 20) {
            this.msgMember.push({severity: 'error', detail: 'Passwords must be between 6 and 20 symbols!'});
        } else if (userData.password.length < 6 || userData.password.length > 20) {
            this.msgMember.push({severity: 'error', detail: 'Passwords must be between 6 and 20 symbols!'});
        } else if (!this.validateTrim()) {
            // used for checking if the password starts or ends with empty space
            return;
        } else if (!this.validateAddressNewMember()) {
            this.msgMember.push({
                severity: 'error',
                detail: 'Address can not be partially filled. Please fill all the fields or leave them empty.'
            });
            return;
        } else if ('' === this.membermarket) {
            this.msgMember.push({severity: 'error', detail: 'Please select market!'});
        } else {
            /// cause of eventual trimming of address
            userData = this.commonDataService.deleteEmptyObjectProperties(this.commonDataService.trimObjectData(this.editMembersData.value));
            userData.email = userData.email.toLowerCase();
            userData.country = this.country;
            if (userData.phone && userData.phone.length < 8) {
                delete userData.phone;
            } else if (!userData.phone) {
                userData.phone = '';
            }

            if (userData.mobilePhone && userData.mobilePhone.length < 8) {
                delete userData.mobilePhone;
            } else if (!userData.mobilePhone) {
                userData.mobilePhone = '';
            }
            // date formatting
            if (userData.birthDate) {
                userData.birthDate = userData.birthDate.getFullYear()
                    + '-' + (userData.birthDate.getMonth() + 1)
                    + '-' + userData.birthDate.getDate();
            }

            this.hideUI = true;
            this.membersService.createMember(userData)
                .subscribe(
                    data => {
                        this.hideUI = false;
                        this.foundMembers = [];
                        this.foundMembers.push({'id': data.id, 'fullName': data.firstName + ' ' + data.lastName});
                        this.isCreateNewCustomer = false;
                        this.msgSearchMember.push({
                            severity: 'success',
                            detail: 'You have successfully added new member and its shown in the search results below!'
                        });
                    },
                    error => {
                        this.hideUI = false;
                        if (!error || !error.parameterErrors) {
                            this.msgMember.push({severity: 'error', detail: error.message});
                            return;
                        }
                        for (let i = 0; i < error.parameterErrors.length; i++) {
                            this.msgMember.push({severity: 'error', detail: error.parameterErrors[i].message});
                        }
                    }
                );
        }
    }

    validateTrim() {
        const userData = this.commonDataService.deleteEmptyObjectProperties(this.commonDataService.trimObjectData(this.editMembersData.value));

        if (userData.password.startsWith(' ') || userData.rePassword.startsWith(' ') || userData.password.startsWith('   ') || userData.rePassword.startsWith('  ')) {
            this.msgMember.push({severity: 'error', detail: 'Password can not start with empty space or tab! Please modify it.'});
            return false;
        }

        if (userData.password.endsWith(' ') || userData.rePassword.endsWith(' ') || userData.password.endsWith('   ') || userData.rePassword.endsWith('  ')) {
            this.msgMember.push({severity: 'error', detail: 'Password can not ends with empty space or tab! Please modify it.'});
            return false;
        }

        return true;
    }

    validateAddressNewMember() {
        const userData = this.commonDataService.deleteEmptyObjectProperties(this.commonDataService.trimObjectData(this.editMembersData.value));
        if ('' === userData.city) {
            userData.city = undefined;
            this.editMembersData.value.city = undefined;
        }
        if ('' === userData.address) {
            userData.address = undefined;
            this.editMembersData.value.address = undefined;
        }
        if (!userData.city && !userData.address) {
            this.editMembersData.value.country = undefined;
            this.editMembersData.value.state = undefined;
            return true;
        } else if (userData.city && userData.address) {
            return true;
        } else {
            return false;
        }
    }

    formatPhone(event, phone) {
        this.phone = this.commonDataService.formatPhone(event, phone, this.phone);
    }

    formatMobilePhone(event, phone) {
        this.mobilePhone = this.commonDataService.formatPhone(event, phone, this.mobilePhone);
    }

    newMemberCancel() {
        this.isCreateNewCustomer = false;
        this.msgMember = [];
        this.resetForm();
    }

    newCustomer() {
        this.msgMember = [];
        this.foundMembers = [];
        this.selectedCustomerName = '';
        this.selectedCustomerId = -1;
        this.isCreateNewCustomer = true;
        this.resetForm();
    }
    ///end new member part

    // dropdowns part
    fillPaymentLocationDropdown() {
        this.paymentLocationDropdown = [];
        this.paymentLocationDropdown.push({label: '- Please Select -', value: undefined});
        this.paymentLocationDropdown.push({label: 'Office',  value: 'Office'});
        this.paymentLocationDropdown.push({label: 'Phone',  value: 'Phone'});
    }

    fillMarketsDropdown() {
        if (this.commonDataService.activeMarkets.length === 0) {
            this.populateMarketsList(true);
        } else {
            this.markets = this.commonDataService.modifyToSelectItems(this.commonDataService.activeMarkets);
            this.markets.unshift({
                label: ' Please select...',
                value: ''
            });
        }
    }

    populateMarketsList(active) {
        this.settingsService.listMarkets(active ? this.commonDataService.activeMarketsFilterObject : this.commonDataService.allMarketsFilterObject)
            .subscribe(
                data => {
                    if (data) {
                        if (!data || !data.markets) {
                            this.markets = [];
                        } else {
                            active ? this.commonDataService.setActiveMarkets(data.markets) : this.commonDataService.setAllMarkets(data.markets);
                            this.markets = this.commonDataService.modifyToSelectItems(data.markets);
                            this.markets.unshift({
                                label: ' Please select...',
                                value: ''
                            });
                        }
                    }
                }, error => {
                    console.log('Error', error);
                    this.msgSearchMember.push({severity: 'error', detail: error.message});
                });
    }

    static sortProductsByName(a, b) {
        if (a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase()) {
            return -1;
        }
        if (a.name.toLocaleLowerCase() > b.name.toLocaleLowerCase()) {
            return 1;
        }
        return 0;
    }

    fillProductsDropdown() {
        this.productsDropdown = [];
        this.productsDropdown.push({label: '- Please Select -', value: undefined});
        this.productsDropdown.push({label: '- Custom Product -', value: 'willUseCustomValue'});
        this.msgSearchMember = [];
        const objToSend: any = {
            'paging': {
                'page': 1,
                'numRows': 0
            }
        };
        objToSend.filter = objToSend.filter || {};
        objToSend.filter.fields = objToSend.filter.fields || [];
        objToSend.filter.fields.push({
            'operation': 'IN',
            'field': 'status',
            'value': ['ENABLED']
        });
        this.ordersService.getProductsList(objToSend)
        .subscribe(
            data => {
                if (data.products) {
                    this.allProducts = data.products;
                    const pinnedProducts = [];
                    const notPinnedProducts = [];
                    const sortedProducts = [];

                    for (let i = 0; i < data.products.length; i++) {
                        if (data.products[i].pinned) {
                            pinnedProducts.push(data.products[i]);
                        } else {
                            notPinnedProducts.push(data.products[i]);
                        }
                    }
                    pinnedProducts.sort(AddEditOrdersComponent.sortProductsByName);
                    notPinnedProducts.sort(AddEditOrdersComponent.sortProductsByName);
                    sortedProducts.push(...pinnedProducts);
                    sortedProducts.push(...notPinnedProducts);

                    this.productsHolder = sortedProducts;
                    for (let i = 0; i < sortedProducts.length; i++) {
                        if ('ENABLED' === sortedProducts[i].status && 'TICKET' !== sortedProducts[i].productType) {
                            this.productsDropdown.push({label: sortedProducts[i].name, value: sortedProducts[i].id});
                        }
                    }
                }
                this.hideUI = false;
            },
            error => {
                this.msgSearchMember.push({ severity: 'warn', detail: 'Loading products list failed!' });
                this.hideUI = false;
            }
        );
    }

    fillAttributionDropdown() {
        let venturaSchoolsList = [];
        venturaSchoolsList = this.getVenturaSchoolsList();
        this.attributionDropdown = [];
        this.attributionDropdown.push({label: '- Please Select -', value: undefined});
        this.attributionDropdown.push({label: '- Other/Not Listed -', value: 'willUseCustomValue'});
        this.ordersService.getBenefactorList()
            .subscribe(
                data => {
                    if (data.values) {
                        for (let i = 0; i < data.values.length; i++) {
                            this.attributionDropdown.push({label: data.values[i].value, value: data.values[i].value});
                        }
                        for (let j = 0; j < venturaSchoolsList.length; j++) {
                            this.attributionDropdown.push({label: venturaSchoolsList[j], value: venturaSchoolsList[j]});
                        }
                        this.attributionDropdown.sort(function (a, b) {
                            return (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0);
                        });
                    } else {
                        this.msgSearchMember.push({severity: 'warn', detail: 'No Benefactor were found!'});
                    }
                    this.hideUI = false;
                },
                error => {
                    this.hideUI = false;
                    this.msgSearchMember.push({severity: 'warn', detail: 'Loading Benefactor list failed!'});
                }
            );
    }

    getVenturaSchoolsList() {
        const schoolsList = [];
        schoolsList.push('ACHS PTSA');
        schoolsList.push('ATLAS (Saticoy) Elementary School');
        //schoolsList.push("Balboa Middle School- Music");
        schoolsList.push('Blanche Reynolds Elementary School');
        schoolsList.push('Calvary Christian High School');
        schoolsList.push('Camarillo Heights Elementary School');
        schoolsList.push('Children\'s World Nursery School');
        schoolsList.push('Christa McAullife Elementary School');
        schoolsList.push('Citrus Glen Elementary School');
        schoolsList.push('Community Presbyterian Church Preschool');
        schoolsList.push('Cornerstone Christian School');
        schoolsList.push('Dos Caminos Elementary');
        schoolsList.push('Elmhurst Elementary School');
        schoolsList.push('Foothill Technology High School');
        schoolsList.push('Frontier High School');
        schoolsList.push('Juanamaria Elementary');
        schoolsList.push('Junipero Serra School');
        schoolsList.push('Las Posas Elementary School');
        schoolsList.push('Meiners Oaks Elementary School');
        schoolsList.push('Mira Monte Elementary-6th Grade');
        schoolsList.push('Pacific Camps');
        schoolsList.push('Pleasant Valley School of Engineering Arts');
        schoolsList.push('Poinsettia Elementary-6th Grade');
        schoolsList.push('Rancho Rosal Elementary');
        schoolsList.push('Rio Vista Middle School-Band');
        schoolsList.push('Rio Vista Middle School-Music');
        schoolsList.push('Sonshine Preschool');
        schoolsList.push('St. Anthony\'s Catholic School');
        schoolsList.push('Sunset Elementary');
        schoolsList.push('UPS Charter School');
        schoolsList.push('Will Rogers Elementary School');
        return schoolsList;
    }

    fillSelectedPaymentMethodDropdown() {
        this.paymentMethodDropdown = [];
        this.paymentMethodDropdown.push({label: '- Please Select -', value: undefined});

        //make a call maybe
        this.paymentMethodDropdown.push({label: 'Cash / Check', value: 'Cash/Check'});
        this.paymentMethodDropdown.push({label: 'Credit Card (offline)', value: 'Credit card(offline)'});
        this.paymentMethodDropdown.push({label: 'Credit Card', value: 'Credit card'});
    }

    fillShippingDropdown() {
        this.shippingDropdown = [];
        this.shippingDropdown.push({label: '- Please Select -', value: undefined});
        this.shippingDropdown.push({label: '- Customer will pickup in office -', value: 'office'}); ////?
        this.shippingDropdown.push({label: '- Add New Address -', value: 'addNew'});
        this.ordersService.getAddressesList(this.selectedCustomerId)
        .subscribe(
            data => {
                this.selectedCustomer = data;
                if (data.addresses) {
                    for (let i = 0; i < data.addresses.length; i++) {
                        if (data.addresses[i].asString) {
                            undefined !== data.addresses[i].shippingName ?
                                this.shippingDropdown.push({label: data.addresses[i].shippingName + ', ' + data.addresses[i].asString
                                + (data.addresses[i].apartment && data.addresses[i].apartment != '' ? ', apt.' + data.addresses[i].apartment : ''), value: data.addresses[i].id}) :
                                this.shippingDropdown.push({label: data.addresses[i].asString
                                + (data.addresses[i].apartment && data.addresses[i].apartment != '' ? ', apt.' + data.addresses[i].apartment : ''), value: data.addresses[i].id});
                        }
                    }
                } else {
                    //console.log('no addresses');
                }
                this.fullShippingDD = this.shippingDropdown.slice();
            },
            error => {
                //console.log('getAddressesList loading failed');
            }
        );
    }

    fillRepresentativeDropdown() {
        this.representativeDropdown = [];
        this.representativeDropdown.push({label: '- Please Select -', value: undefined});
        this.employeesService.getAllEmployees()
            .subscribe(
                data => {
                    if (!data || !data.employees) {
                        return;
                    }

                    for (let i = 0; i < data.employees.length; i++) {
                        if (data.employees[i].enabled && data.employees[i].orderAllowed) {
                            this.representativeDropdown.push({
                                label: data.employees[i].name,
                                value: data.employees[i].id
                            });
                        }
                    }
                },
                error => {
                    //console.log(error);
                }
            );
    }
    // end of dropdowns part

    //new address part
    newAddressClear() {
        this.msgsNewAddress = [];
        this.newShippingAddressObj.name = '';
        this.newShippingAddressObj.address = '';
        this.newShippingAddressObj.apartment = '';
        this.newShippingAddressObj.suite = '';
        this.newShippingAddressObj.city = '';
        this.newShippingAddressObj.state = 'CA';
        this.newShippingAddressObj.zip = '';
        this.newMemberAddressSubmitted = false;
    }

    newAddressCancel() {
        this.newAddressClear();
        this.sellectedShipping = undefined;
        this.selectedPaymentLocation = undefined;

    }

    validateAddress() {
        if (this.newShippingAddressObj.city) {
            this.newShippingAddressObj.city = this.newShippingAddressObj.city.trim();
        }
        if (this.newShippingAddressObj.state) {
            this.newShippingAddressObj.state = this.newShippingAddressObj.state.trim();
        }
        if (this.newShippingAddressObj.address) {
            this.newShippingAddressObj.address = this.newShippingAddressObj.address.trim();
        }
        if (this.newShippingAddressObj.apartment) {
            this.newShippingAddressObj.apartment = this.newShippingAddressObj.apartment.trim();
        }
        if (this.newShippingAddressObj.zip) {
            this.newShippingAddressObj.zip = this.newShippingAddressObj.zip.trim();
        }
        if (this.newShippingAddressObj.name) {
            this.newShippingAddressObj.name = this.newShippingAddressObj.name.trim();
        }

        this.newShippingAddressObj = new Object(this.newShippingAddressObj);
        if (!this.newShippingAddressObj.city || !this.newShippingAddressObj.state ||
            !this.newShippingAddressObj.address || !this.newShippingAddressObj.zip ||
            !this.newShippingAddressObj.name || !this.newShippingAddressObj.city.length ||
            !this.newShippingAddressObj.state.length || !this.newShippingAddressObj.address.length ||
            !this.newShippingAddressObj.zip.length || !this.newShippingAddressObj.name.length){
                this.msgsNewAddress.push({ severity: 'warn', detail: 'Please fill all the required fields of an address!' });
                return false;
        } else if (isNaN(this.newShippingAddressObj.zip) && this.newShippingAddressObj.zip != undefined ) {
            this.msgsNewAddress.push({ severity: 'warn', detail: 'ZIP code should contain digits only' });
            return false;
        }
        return true;
    }

    newAddressSubmit() {
        this.msgsNewAddress = [];
        this.newMemberAddressSubmitted = true;
        if (!this.validateAddress()) {
            return false;
        }

        const obj = {
            city: this.newShippingAddressObj.city,
            state: this.newShippingAddressObj.state,
            address: this.newShippingAddressObj.address,
            apartment: this.newShippingAddressObj.apartment,
            zip: this.newShippingAddressObj.zip,
            country: 'United States',
            shipTo: this.newShippingAddressObj.name
        };
        this.hideUI = true;

        this.ordersService.memberAddAddress(this.selectedCustomerId, obj)
        .subscribe(
            data => {
                this.hideUI = false;
                this.shippingDropdown.push({label: this.newShippingAddressObj.name + ', United States, ' + this.newShippingAddressObj.city + ', ' + this.newShippingAddressObj.address
                + (this.newShippingAddressObj.apartment && this.newShippingAddressObj.apartment !== '' ? ', apt.' + this.newShippingAddressObj.apartment : ''), value: data.id});
                this.fullShippingDD.push({label: this.newShippingAddressObj.name + ', United States, ' + this.newShippingAddressObj.city + ', ' + this.newShippingAddressObj.address
                + (this.newShippingAddressObj.apartment && this.newShippingAddressObj.apartment !== '' ? ', apt.' + this.newShippingAddressObj.apartment : ''), value: data.id});
                this.msgsNewAddress.push({ severity: 'success', detail: 'Address has been created!' });
                setTimeout(() => {
                    this.msgsNewAddress = [];
                }, 20000);
                this.newMemberAddressSubmitted = false;

                this.sellectedShipping = data.id;
                this.newAddressClear();
            },
            error => {
                this.hideUI = false;
                this.msgsNewAddress.push({ severity: 'error', detail: 'Address creation has failed!' });
            }
        );
    }
    //end of new address part
    getCustomer() {
        this.selectedCustomerId = -1;
        this.selectedCustomerName = '';
        this.foundMembers = [];
        this.msgSearchMember = [];
        if (this.isCreateNewCustomer) {
            this.msgSearchMember.push({ severity: 'warn', detail: 'Please close the add new customer panel before searching!' });
            return;
        }
        if (!this.searchedCustomer || !this.searchedCustomer.length) {
            this.msgSearchMember.push({ severity: 'warn', detail: 'Please fill search criteria!' });
            return;
        }
        const obj = {
            'paging': {
                'page': 1,
                'numRows': 99999,
            },
            'filter': {
                'globalSearch': this.searchedCustomer
            },
            'sorting': []
        };
        this.hideUI = true;
        this.ordersService.getMembersForOrder(obj)
        .subscribe(
            data => {
                this.hideUI = false;
                if (data.values && data.values.length) {
                    this.foundMembers = data.values;
                } else {
                    this.msgSearchMember.push({ severity: 'warn', detail: 'No members matching the search criteria!' });
                }
            },
            error => {
                this.hideUI = false;
                if (error && error.parameterErrors && error.parameterErrors.length) {
                    this.msgSearchMember.push({severity: 'error', detail: error.parameterErrors[0].message});
                } else {
                    this.msgSearchMember.push({severity: 'error', detail: error.message});
                }
            }
        );
    }

    selectMember(m) {
        this.commonDataService.setUnsavedChanges(true);
        this.selectedCustomerId = m.id;
        this.selectedCustomerName = m.fullName ;
        this.foundMembers = [];
        this.fillShoppingCard();
        this.fillSelectedPaymentMethodDropdown();
        this.fillShippingDropdown();
        this.fillRepresentativeDropdown();
    }

    fillShoppingCard() {
        this.shoppingCard = [];
        if (this.isNew) {
            this.shoppingCard.push(new OneOrderShoppingItem(null));
        } else {
            /// here fill all the items form the get request;
        }
    }

    cancelCustom(index) {
        this.shoppingCard[index].isCustom = false;
        this.shoppingCard[index].name = undefined;
    }

    addAnotherProductInCard() {
        const tmp = new OneOrderShoppingItem(null);
        this.shoppingCard.push(tmp);
    }

    removeProductInCard(index) {
        this.shoppingCard.splice(index, 1);
        this.rearangeShippingDropdown();
        this.calculateShoppingCardValues(true);
    }

    rearangeShippingDropdown() {
        let hasShipOnly = false, hasOffiseOnly = false;
        let result: any;
        let val: any;
        for (let i = 0; i < this.shoppingCard.length; i++) {
            if (!this.shoppingCard[i].isCustom) {
                val  = this.shoppingCard[i].name;
                result  = this.productsHolder.filter(function(o){return o.id === val; } );
                if (result.length && 'SHIPPED' === result[0].productDelivery) {
                    hasShipOnly = true;
                }
                if (result.length && 'CUSTOMER_PICKUP' === result[0].productDelivery) {
                    hasOffiseOnly = true;
                }
            }
        }
        if (hasOffiseOnly) {
            this.newAddressCancel();
            if (this.shippingDropdown.length != 2) {
                this.shippingDropdown = [];
                this.shippingDropdown.push({label: '- Please Select -', value: undefined});
                this.shippingDropdown.push({label: '- Customer will pickup in office -', value: 'office'});
                this.sellectedShipping = undefined;
            }
        } else if (hasShipOnly) {
            this.shippingDropdown = this.fullShippingDD.slice();
            let index = -1;
            for (let i = 0; i < this.shippingDropdown.length; i++) {
                if ('office' === this.shippingDropdown[i].value) {
                    index = i;
                    break;
                }
            }
            if (index > -1) {
                this.shippingDropdown.splice(index, 1);
                'office' === this.sellectedShipping ? this.sellectedShipping = undefined : this.sellectedShipping;
            }
        } else {
            this.shippingDropdown = this.fullShippingDD.slice();
        }
    }

    onSelectedProductChange(_value, index) {

        if ('willUseCustomValue' === _value.value) {
            this.shoppingCard[index].isCustom = true;
            this.shoppingCard[index].name = '';
            this.shoppingCard[index].qty = 0;
            this.shoppingCard[index].cost = 0;
            this.shoppingCard[index].total = 0;
        }
        let result: any;
        let val: any;

        if (!isNaN(_value.value)) {
            val = _value.value;
            result = this.productsHolder.filter(function (o) {
                return o.id === val;
            });
            if (result.length) {
                if (!isNaN(result[0].price)) {
                    this.shoppingCard[index].cost = result[0].price;
                }
            }
        }
        this.attributionDisabled = true;
        for (let i = 0; i < this.shoppingCard.length; i++) {
            if (!this.shoppingCard[i].isCustom) {
                val = this.shoppingCard[i].name;
                result = this.productsHolder.filter(function (o) {
                    return o.id === val;
                });
                if (result.length && result[0].fundraiserBenefit) {
                    this.attributionDisabled = false;
                }
            }
        }
        this.rearangeShippingDropdown();
        this.calculateShoppingCardValues(true);
    }

    calculateShoppingCardValues(willCalcShipping) {
        let tmpTotal = 0;
        let tmpTax = 0;
        let result: any;
        let val: any;
        //debugger;
        let tmpPr;
        for (let i = 0;  i < this.shoppingCard.length; i++) {
            while (this.shoppingCard[i].qty && this.shoppingCard[i].qty.length > 1 && this.shoppingCard[i].qty.startsWith('0')) {
                this.shoppingCard[i].qty = new String(this.shoppingCard[i].qty.substr(1));
            }
            if (!isNaN(this.shoppingCard[i].qty) && !isNaN(this.shoppingCard[i].cost)) {
                if (Number(this.shoppingCard[i].cost) > 99999) {
                    this.shoppingCard[i].cost = Number(99999);
                    this.shoppingCard[i] = new OneOrderShoppingItem(this.shoppingCard[i]);
                }
                if (Number(this.shoppingCard[i].qty) > 99999) {
                    this.shoppingCard[i].qty = Number(99999);
                    this.shoppingCard[i] = new OneOrderShoppingItem(this.shoppingCard[i]);
                }
                this.shoppingCard[i].total =  Number(this.shoppingCard[i].qty * this.shoppingCard[i].cost).toFixed(2);
                tmpTotal += Number(this.shoppingCard[i].total);

                if (!this.shoppingCard[i].isCustom && this.shoppingCard[i].name){
                    val  = this.shoppingCard[i].name;
                    tmpPr  = this.productsHolder.filter(function(o){return o.id === val; } );
                    if (tmpPr.length && tmpPr[0].taxable) {
                        tmpTax += Number(this.shoppingCard[i].cost) * Number(this.shoppingCard[i].qty) * 0.075;
                    }
                }
            }
        }
        if (willCalcShipping) {
            this.calcShipping();
        } else {

        }

        this.subtotal = Number(tmpTotal.toFixed(2));
        if (isNaN(this.shippingPrice)) {
            this.shippingPrice = 0;
        }

        if (this.promoCode) {
            this.applyPromoCode();
        }else {
            this.taxes = Number(tmpTax.toFixed(2)).toString();
            this.grandTotal = ((this.subtotal + Number(this.shippingPrice) + Number(this.taxes)).toFixed(2)).toString();
        }
    }

    calcShipping() {
        if (this.sellectedShipping && 'office' !== this.sellectedShipping && 'addNew' !== this.sellectedShipping) {
            this.shippingPrice = 0.00;
            let tmpPrice = 0;
            let result: any;
            let val: any;
            for (let i = 0; i < this.shoppingCard.length; i++) {
                if (!this.shoppingCard[i].isCustom) {
                    val = this.shoppingCard[i].name;
                    result = this.productsHolder.filter(function (o) {
                        return o.id === val;
                    });
                    if (result.length && result[0].shippingCost) {
                        tmpPrice += result.length && result[0].shippingCost;
                    }
                }
            }
            this.shippingPrice = tmpPrice;
        }
    }

    shippingChange() {
        if ('office' === this.sellectedShipping) {
            this.shippingPrice = 0;
            this.calculateShoppingCardValues(false);
        } else {
            this.calculateShoppingCardValues(true);
        }
    }

    _makeOrderToSave() {
        const ord: any = {
            'memberId': this.selectedCustomerId,
            'items': [],
            'tax': this.taxes,
            'shipping': Number(this.shippingPrice),

            'paymentMethod': this.selectedPaymentMethod,
            'notes': undefined,
            'paymentLocation': this.selectedPaymentLocation,
            'employeeId': this.selectedRepresentative,
            'beneficiaryId': this.selectedBeneficiary === '' ? null : this.selectedBeneficiary,
            'additionalInfo': this.additionalInfo,
            'clientVersion': this.platformDesc,
            /*"fundraiserBenefit" : this.attribution*/
        };

        for (let i = 0; i < this.shoppingCard.length; i++) {
            ord.items.push(
                {
                    'productId': this.shoppingCard[i].isCustom ? null : this.shoppingCard[i].name,
                    'productName': this.shoppingCard[i].isCustom ? this.shoppingCard[i].name : null,
                    'quantity': Number(this.shoppingCard[i].qty),
                    'totalPrice': this.shoppingCard[i].total
                }
            );
        }

        ord.market = this.market;

        if ('Credit card' === this.selectedPaymentMethod) {
            ord.creditCard = {};
            ord.creditCard.ccNo = this.selectedPaymentIsCard.number;
            if (this.selectedPaymentIsCard.ccv) {
                ord.creditCard.ccCode = this.selectedPaymentIsCard.ccv; // not obligatory
            }
            ord.creditCard.ccName = this.selectedPaymentIsCard.fname + ' ' + this.selectedPaymentIsCard.lname;
            ord.creditCard.expMonth = this.selectedPaymentIsCard.expirationMonth;
            ord.creditCard.expYear = this.selectedPaymentIsCard.expirationYear;
        } else {
            'Yes' === this.selectedPaymethodRadioBtn ? ord.orderPaid = true : ord.orderPaid = false;
        }

        if (this.sellectedShipping && 'office' !== this.sellectedShipping) {
            ord.shippingAddressId = this.sellectedShipping;
        }

        if (this.promoCode) {
            ord.promoCode = this.promoCode;
        }

        return ord;
    }

    _validateProducts() {
        let result = true;
        let customValid = true;
        let haveMoreThanInventory = false;
        let orphanUpgradeProductFound = false;

        for (let i = 0; i < this.shoppingCard.length; i++) {
            if (!this.shoppingCard[i].qty || isNaN(this.shoppingCard[i].qty) || parseInt(this.shoppingCard[i].qty) != this.shoppingCard[i].qty ||
                isNaN(parseInt(this.shoppingCard[i].qty, 10)) || (parseInt(this.shoppingCard[i].qty, 10) < 1)) {
                result = false;
                break;
            }

            if (!this.shoppingCard[i].cost || isNaN(this.shoppingCard[i].cost) || parseFloat(this.shoppingCard[i].cost) !== this.shoppingCard[i].cost ||
                (this.shoppingCard[i].cost.toString().split('.')[1] || []).length > 2 || (parseFloat(this.shoppingCard[i].cost) < 0.01)) {
                result = false;
                break;
            }

            if (!this.shoppingCard[i].total || isNaN(this.shoppingCard[i].total) || parseFloat(this.shoppingCard[i].total) != this.shoppingCard[i].total ||
                (this.shoppingCard[i].total.toString().split('.')[1] || []).length > 2 || (parseFloat(this.shoppingCard[i].total) < 0.01)) {
                result = false;
                break;
            }

            if (this.shoppingCard[i].isCustom && (!this.shoppingCard[i].name || !this.shoppingCard[i].name.toString().length)) {
                customValid = false;
                break;
            }

            if (!this.shoppingCard[i].isCustom) {
                if (!this.shoppingCard[i].name || isNaN(this.shoppingCard[i].name) || parseInt(this.shoppingCard[i].name) != this.shoppingCard[i].name ||
                    isNaN(parseInt(this.shoppingCard[i].name, 10)) || (parseInt(this.shoppingCard[i].name, 10) < 1)) {
                    result = false;
                    break;
                }

                //code for more than inventory
                const tmpPr = this.productsHolder.find(o => o.id === this.shoppingCard[i].name);
                if (tmpPr && 'SPECIFIC' === tmpPr.productInventoryType && (tmpPr.productInventory - tmpPr.totalItemsSold) < this.shoppingCard[i].qty) {
                    haveMoreThanInventory = true;
                    this.orderSaveMsgs.push({
                        severity: 'error',
                        detail: 'Product ' + tmpPr.name + ' has only ' + (tmpPr.productInventory - tmpPr.totalItemsSold) + ' items left!'
                    });
                    break;
                }

                for (let j = i + 1; j < this.shoppingCard.length; j++) {
                    if (this.shoppingCard[i].name === this.shoppingCard[j].name) {
                        const val = this.shoppingCard[i].name;
                        const tmpPr = this.productsHolder.filter(function (o) {
                            return o.id === val;
                        });
                        if (tmpPr.length) {
                            this.orderSaveMsgs.push({
                                severity: 'error',
                                detail: 'You have selected product ' + tmpPr[0].name + ' more than once. Please have it as a single purchase!'
                            });
                        }
                        return false;
                    }
                }
            }

            const product = this.allProducts.find(prd => {
                return prd.id === this.shoppingCard[i].name;
            });
            if (product && product.productType === 'UPGRADE') {
                const parentProductId = product.parentId;
                let parentFound = false;

                this.shoppingCard.forEach(parentProduct => {
                    const advancedProd = this.allProducts.find(prd => {
                        return prd.id === parentProduct.name;
                    });
                    if (advancedProd && advancedProd.id === parentProductId) {
                        parentFound = true;
                    }
                });
                if (!parentFound) {
                    if (this.selectedCustomer !== null) {
                        const activeMembership = this.selectedCustomer.productCards.find(productCard => productCard.product.id === parentProductId);
                        if (typeof activeMembership === 'undefined') {
                            orphanUpgradeProductFound = true;
                            break;
                        }
                    } else {
                        orphanUpgradeProductFound = true;
                        break;
                    }
                }
            }
        }
        if (!result) {
            this.orderSaveMsgs.push({
                severity: 'error',
                detail: 'Please ensure all the products are selected and have valid integer Qty and valid price!'
            });
            return false;
        }
        if (!customValid) {
            this.orderSaveMsgs.push({severity: 'error', detail: 'Please ensure all custom products have none empty names!'});
            return false;
        }
        if (orphanUpgradeProductFound) {
            this.orderSaveMsgs.push({
                severity: 'error',
                detail: 'Please ensure all purchased upgrade products have appropriate base products!'
            });
            return false;
        }

        return result && customValid && !haveMoreThanInventory && !orphanUpgradeProductFound;
    }

    _validateSandP() {
        let valid = true;
        if ((!this.shippingPrice && this.shippingPrice !== 0) || isNaN(this.shippingPrice) || parseFloat(this.shippingPrice.toString()) !== this.shippingPrice ||
            (this.shippingPrice.toString().split('.')[1] || []).length > 2 || (parseFloat(this.shippingPrice.toString()) < 0)) {
            valid = false;
            this.orderSaveMsgs.push({severity: 'error', detail: 'Please fill in valid shipping!'});
        }

        if (!this.selectedPaymentMethod) {
            valid = false;
            this.orderSaveMsgs.push({severity: 'error', detail: 'Please fill in valid payment method!'});
        }

        if (!this.selectedPaymentLocation) {
            valid = false;
            this.orderSaveMsgs.push({severity: 'error', detail: 'Please fill in valid payment location!'});
        }

        if (!this.selectedRepresentative) {
            valid = false;
            this.orderSaveMsgs.push({severity: 'error', detail: 'Please fill in valid employee!'});
        }

        if ('addNew' === this.sellectedShipping) {
            valid = false;
            this.orderSaveMsgs.push({severity: 'error', detail: 'Please add the address or cancel the adding process!'});
        }

        if ('' === this.market) {
            valid = false;
            this.orderSaveMsgs.push({severity: 'error', detail: 'Please select market!'});
        }

        if ('Credit card' === this.selectedPaymentMethod) {
            if (!this.selectedPaymentIsCard.ccv || '' === this.selectedPaymentIsCard.ccv || this.selectedPaymentIsCard.ccv.length < 3 ||
                this.selectedPaymentIsCard.ccv.length > 4 || isNaN(parseInt(this.selectedPaymentIsCard.ccv)) || !(/^\d+$/.test(this.selectedPaymentIsCard.ccv))) {
                this.orderSaveMsgs.push({severity: 'error', detail: 'CVV should contain 3 or 4 digits depending on your card!'});
                return false;
            }
            if (isNaN(this.selectedPaymentIsCard.expirationYear) || parseInt(this.selectedPaymentIsCard.expirationYear) != this.selectedPaymentIsCard.expirationYear ||
                isNaN(parseInt(this.selectedPaymentIsCard.expirationYear, 10)) || (parseInt(this.selectedPaymentIsCard.expirationYear, 10) < (new Date(Date.now())).getFullYear() % 100) ||
                (parseInt(this.selectedPaymentIsCard.expirationYear, 10) > 36)) {
                valid = false;
                this.orderSaveMsgs.push({
                    severity: 'error',
                    detail: 'Expiration year must be between ' + (new Date(Date.now())).getFullYear() % 100 + ' and 36!'
                });
                return false;
            }
            if (isNaN(this.selectedPaymentIsCard.expirationMonth) || parseInt(this.selectedPaymentIsCard.expirationMonth) != this.selectedPaymentIsCard.expirationMonth ||
                isNaN(parseInt(this.selectedPaymentIsCard.expirationMonth, 10)) || (parseInt(this.selectedPaymentIsCard.expirationMonth, 10) < 1) ||
                (parseInt(this.selectedPaymentIsCard.expirationMonth, 10) > 12)) {
                valid = false;
                this.orderSaveMsgs.push({severity: 'error', detail: 'Expiration month must be between 1 and 12!'});
                return false;
            }
            if ((parseInt(this.selectedPaymentIsCard.expirationYear) === (new Date(Date.now())).getFullYear() % 100 && parseInt(this.selectedPaymentIsCard.expirationMonth) < (new Date(Date.now())).getMonth() + 1)) {
                this.orderSaveMsgs.push({severity: 'error', detail: 'Your card has already expired!'});
                return false;
            }


            if (!this.selectedPaymentIsCard.number || !this.selectedPaymentIsCard.expirationMonth ||
                !this.selectedPaymentIsCard.expirationYear || !this.selectedPaymentIsCard.fname ||
                !this.selectedPaymentIsCard.lname) {
                // this.selectedPaymentIsCard.ccv; not obligatory
                valid = false;
                this.orderSaveMsgs.push({severity: 'error', detail: 'Please fill in valid card details!'});
            }
        }
        /// METHOD FOR SHIPPING
        // console.log(this.sellectedShipping);
        if ('office' !== this.sellectedShipping && 'addNew' !== this.sellectedShipping) {
            let val, result;
            if (this.sellectedShipping === undefined) {
                valid = false;
                this.orderSaveMsgs.push({severity: 'error', detail: 'Please select a shipping method'});
            }
            for (let i = 0; i < this.shoppingCard.length; i++) {
                if (!this.shoppingCard[i].isCustom) {
                    val = this.shoppingCard[i].name;
                    result = this.productsHolder.filter(function (o) {
                        return o.id === val;
                    });
                    if (result.length && 'CUSTOMER_PICKUP' === result[0].productDelivery) {
                        valid = false;
                        this.orderSaveMsgs.push({
                            severity: 'error',
                            detail: 'Product ' + result[0].name + ' must be picked up from office. Please select office from shipping information'
                        });
                    }
                }
            }
        }
        return valid;
    }

    saveForm() {
        this.orderSaveMsgs = [];
        if (!this._validateProducts()) {
            return;
        }

        if (!this._validateSandP()) {
            return;
        }

        if (this.orderSaved) {
            this.orderSaveMsgs = [];
            this.orderSaveMsgs.push({severity: 'error', detail: 'Order was already saved and you can\'t edit it!'});
            return;
        }

        const orderToSave = this._makeOrderToSave();
        this.hideUI = true;
        this.ordersService.createOrder(orderToSave)
            .subscribe(
                data => {
                    this.commonDataService.setUnsavedChanges(false);
                    this.orderSaveMsgs.push({severity: 'success', detail: 'Order was created successfully'});
                    setTimeout(() => {
                        this.msgs = [];
                    }, 20000);
                    this.orderSaved = true;
                    setTimeout(() => {
                        this.hideUI = false;
                        this.router.navigate(['orders/order-info', data.id]);
                    }, 500);
                },
                error => {
                    this.hideUI = false;

                    if (error && error.parameterErrors && error.parameterErrors.length) {
                        this.orderSaveMsgs.push({severity: 'error', detail: error.parameterErrors[0].message});
                    } else {
                        this.orderSaveMsgs.push({severity: 'error', detail: error.message});
                    }
                    if (4 === error.code) {
                        this.hideUI = true;
                        this.fillProductsDropdown();
                    }
                }
            );
    }

    clearAllProduct() {
        if (this.orderSaved) {
            this.orderSaveMsgs.push({severity: 'warn', detail: 'Order was already saved and you can\'t edit it!'});
            return;
        }
        this.shoppingCard = [];
        this.shoppingCard.push(new OneOrderShoppingItem(null));
        this.shippingPrice = 0;
        this.subtotal = 0;
        this.grandTotal = '0';
        this.taxes = '0';
        this.newAddressCancel();
        this.selectedPaymentLocation = undefined;
        this.msgs = [];
        /*this.attribution = undefined;*/
        this.selectedPaymentMethod = undefined;
        this.selectedPaymentIsCard = {
            fname: '',
            lname: '',
            number: '',
            ccv: '',
            expirationMonth: '',
            expirationYear: ''
        };
        this.selectedPaymethodRadioBtn = 'Yes';
    }

    applyPromoCode() {
        this.submitCode = true;
        const orderPriceParams = {
            memberId: this.selectedCustomerId,
            items: [],
            promoCode: this.promoCode
        };

        this.shoppingCard.forEach(item => {
            if (!isNaN(item.name)) {
                orderPriceParams.items.push({
                    productId: item.name,
                    quantity: item.qty
                });
            }
        });

        this.ordersService.getOrderPrice(orderPriceParams)
            .subscribe(
                data => {
                    console.log('response', data);
                    this.promoCodeDiscount = data.discount;
                    this.taxes = data.tax;
                    this.grandTotal = data.totalPrice;

                    if (this.shippingPrice) {
                        this.grandTotal = ((Number(data.totalPrice) + Number(this.shippingPrice)).toFixed(2)).toString();
                    }

                    this.promoCodeStatus = 'active';
                    this.submitCode = false;
                }, error1 => {
                    this.promoCodeStatus = 'error';
                    this.submitCode = false;

                }
            );

    }
}



// WEBPACK FOOTER //
// ./src/app/orders/add-edit-orders/add-edit-orders.component.ts